import { render, staticRenderFns } from "./SellProduct.vue?vue&type=template&id=568aa748&scoped=true&"
import script from "./SellProduct.vue?vue&type=script&lang=js&"
export * from "./SellProduct.vue?vue&type=script&lang=js&"
import style0 from "./SellProduct.vue?vue&type=style&index=0&id=568aa748&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568aa748",
  null
  
)

export default component.exports